module.exports = __webpack_public_path__ + "img/sv11.44abde45.svg";